export default __webpack_public_path__ + "static/media/ic_plane.3232b2f5.svg";